export default {
  "content": "<path d=\"M0 2.75l8.192-1.13v7.908H0V2.75zm8.192 7.792v7.815L0 17.233v-6.691h8.192zM9.1 1.499L20.003 0v9.528H9.099v-8.03zm10.904 9.043v9.435L9.099 18.478v-7.942h10.904v.006z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "21",
    "height": "20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};